import { render, staticRenderFns } from "./postStory.vue?vue&type=template&id=6f2d4259&scoped=true&"
import script from "./postStory.vue?vue&type=script&lang=js&"
export * from "./postStory.vue?vue&type=script&lang=js&"
import style0 from "./postStory.vue?vue&type=style&index=0&id=6f2d4259&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d4259",
  null
  
)

export default component.exports